
<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true" v-on:closemodal="restoreOriginalData">
        <div slot="title">
            <h2>Price Category Dependencies</h2>
        </div>
        <div slot="body">
            <div v-if="false" class="m-4 text-center">
                <loader />
            </div>

            <div v-else>
                <div class="bg-color-1 lightest text-right p-4">
                    <div class="text-uppercase">
                        Price Category:
                    </div>
                    <div class="price-category-description">
                        {{getProductEditPriceData.audienceTypeGroup !== null ? `${getProductEditPriceData.audienceTypeGroup} - ${getProductEditPriceData.audienceTypeDescription}` : getProductEditPriceData.audienceTypeDescription}}
                    </div>
                </div>

                <div class="px-5 py-4 modal-height">
                    <div class="col-sm-12 min-size">
                        <table class="w-100 table narrow">
                            <thead>
                                <tr class="thead-size">
                                    <th width="50%" class="text-left pl-3"><span class="font-weight-700">Dependency Price Category</span></th>
                                    <th width="25%" class="text-left"><span class="font-weight-700">Quantity</span></th>
                                    <th width="25%" class="text-center">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody class="w-100" v-if="getProductEditPriceData.genderPriceDependencies.length > 0">
                                <tr :class="{'disabled':getProductEditPriceData.isDisabled, 'w-100 tr-size': true}"
                                    v-for="genderPrice, index in getProductEditPriceData.genderPriceDependencies"
                                    v-if="!genderPrice.isDeleted">

                                    <td class="pl-3">
                                        <v-select 
                                            :class="{'notAllowed':getProductEditPriceData.isDisabled, 'drop-size': true}"
                                            :options="genderPriceOptions"
                                            label="audienceTypeDescription"
                                            placeholder="Select Price Category"
                                            :value="genderPrice.genderPriceDependsOn.audienceTypeDescription"
                                            @input="updateDependency(index, $event)"
                                            :disabled="getProductEditPriceData.isDisabled">
                                        </v-select>
                                    </td>

                                    <td class="text-center">
                                        <input
                                            type="text"
                                            class="col-12 btn-height"
                                            placeholder="Quantity"
                                            v-model.number="genderPrice.quantity"
                                            :disabled="getProductEditPriceData.isDisabled"/>
                                    </td>
                                    <td class="text-right pr-3">
                                        <i  class="ico ico-delete m-1 fs-large pointer dark"
                                            v-if="!getProductEditPriceData.isDisabled"
                                            @click="removeDependency(genderPrice, index)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    
                        <div class="text-center dark" v-if="hasDependencies">
                            <div class="py-5" colspan="3">
                                <i class="fs-large fa fa-file-contract color-6"></i>You have no dependencies created
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-12 mt-4 d-flex" :class="{'justify-content-between': genderPriceOptions.length > 0, 'justify-content-end': genderPriceOptions.length === 0}">
                        <div class="mt-4 col-sm-6 add d-flex align-items-center pointer fs-small bold btn-add" v-if="!getProductEditPriceData.isDisabled && genderPriceOptions.length > 0" @click="addDependency">
                            <label for=""></label>
                            <i class="ico-add fs-smallest add-circle color-1"></i> Add new
                        </div>

                        <div class="col-smn-6 d-flex justify-content-end">
                            <div class="d-lfex flex-column">
                                <label class="mb-1">Dependency Setting Type<i class="fa fa-info-circle color-1 ml-1" v-tooltip="createTooltipContent()"></i></label>
                                <v-select 
                                    :class="{'notAllowed':getProductEditPriceData.isDisabled, 'drop-size': true}"
                                    :options="dependencyTypeOptions"
                                    label="name"
                                    placeholder="Select Dependency Type"
                                    :append-to-body="true"
                                    @input="updateDependencyType($event)"
                                    :value="getDependencyValue(getProductEditPriceData.dependencySettings)"
                                    :disabled="getProductEditPriceData.isDisabled">
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" :disabled="getProductEditPriceData.isDisabled" @click="save">Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function() {
            return {
                priceCategoryDependenciesCopy: undefined,
                groupPrices: undefined,
                dependencyTypeOptions: [{name: 'AND', id: 0},{name: 'OR', id: 1}]
            }
        },
        created: function() {
            // Save a copy of productGenderPriceDependecies for cancelation
            this.priceCategoryDependenciesCopy = JSON.parse(JSON.stringify(this.getProductEditPriceData.genderPriceDependencies));
        },
        computed: {
            ...mapGetters([
                'getProductEditPriceData',
                'getGroupPrices',
                'getSelectedEvent'
            ]),
            genderPriceOptions() {         
                const {audienceType, audienceTypeGroup, audienceTypeAssossiation, audienceTypeDescription} = this.getProductEditPriceData;
                const actualPriceCategory = { audienceType, audienceTypeGroup, audienceTypeAssossiation, audienceTypeDescription};

                if (this.getGroupPrices.length > 0) {
                    this.groupPrices = this.getGroupPrices;
                } else {
                    this.groupPrices = this.getSelectedEvent.eventGenderPrices;
                }

                this.groupPrices.forEach(item => {
                    const gpd = item.genderPriceDependencies;
                    
                    if (gpd.length > 0) {
                        gpd.forEach(gpdeps => {
                            const dependsOn = gpdeps.genderPriceDependsOn;
                            const desc = dependsOn.audienceTypeDescription;

                            if (dependsOn && !desc.includes(`${dependsOn.audienceTypeGroup} - `) && dependsOn.audienceTypeGroup && dependsOn.audienceTypeDescription) {
                                // If audienceTypeGroup exists, concatenate ‘group - description’
                                dependsOn.audienceTypeDescription = `${dependsOn.audienceTypeGroup} - ${dependsOn.audienceTypeDescription}`;
                            }
                        })
                    }
                });

                const genderPriceOptions = this.groupPrices.filter(price => {
                    // Comparing properties to find a match
                    return !(price.audienceType === actualPriceCategory.audienceType &&
                             price.audienceTypeGroup === actualPriceCategory.audienceTypeGroup &&
                             price.audienceTypeAssossiation === actualPriceCategory.audienceTypeAssossiation &&
                             price.audienceTypeDescription === actualPriceCategory.audienceTypeDescription);
                }).map(price => {
                    let newDesc = price.audienceTypeDescription;
        
                    if (price.audienceTypeGroup !== null && !newDesc.includes(`${price.audienceTypeGroup} - `)) {
                        newDesc = `${price.audienceTypeGroup} - ${newDesc}`;
                    }
                    
                    return {
                        ...price,
                        audienceTypeDescription: newDesc
                    };
                });

                const usedPriceCategories = new Set(this.getProductEditPriceData.genderPriceDependencies
                    .filter(price => !price.isDeleted)
                    .map(price => `${price.genderPriceDependsOn.audienceType}-${price.genderPriceDependsOn.audienceTypeGroup}-${price.genderPriceDependsOn.audienceTypeDescription}`)
                );

                return genderPriceOptions.filter(price => {
                    // Create key instad id, since id could be 0
                    const key = `${price.audienceType}-${price.audienceTypeGroup}-${price.audienceTypeDescription}`;

                    return !usedPriceCategories.has(key);
                });
            },
            hasDependencies() {
                const dependencies = this.getProductEditPriceData.genderPriceDependencies;
  
                return dependencies.length === 0 || dependencies.every(dependency => dependency.isDeleted === true);
            }
        },
        methods: {
            ...mapActions([
                'normalizeGenderPricesDeps',
                'closeModal',
            ]),
            createTooltipContent(rules) {
                let content = 
                    `<div class="d-flex flex-column">
                        <div class="d-flex mt-1 m-1"><span class="bold">AND:</span>&nbsp; selected, all dependencies must be added.</div>
                        <div class="d-flex mb-1 m-1"><span class="bold">OR:</span>&nbsp; selected, one or more configured dependencies can be added.</div>
                     </div>  `;
                                
                return content;   
            },
            addDependency() {
                const genderPriceDependencies = this.getProductEditPriceData.genderPriceDependencies;
                const { audienceType, audienceTypeGroup, audienceTypeDescription } = this.genderPriceOptions[0];
                const lastValidIndex = genderPriceDependencies.findIndex(price => price.isDeleted);
                let dependencyFound = false;
                const newDependency = {
                    "quantity":  1,
                    "genderPriceDependsOn": {
                        "id": 0,
                        "audienceType": audienceType,
                        "audienceTypeGroup": audienceTypeGroup,
                        "audienceTypeDescription": audienceTypeDescription  
                    },
                    "isDeleted": false,
                    "isNewDep": true
                }
                
                // In cases where there is already a valid dependency and if it has been deleted
                genderPriceDependencies.map((dependency) => {
                    if (dependency.genderPriceDependsOn.audienceType === audienceType 
                        && dependency.genderPriceDependsOn.audienceTypeGroup === audienceTypeGroup) {

                        if (dependency.isDeleted === true) {
                            dependency.isDeleted = false;
                            dependency.quantity = 1;
                            dependencyFound = true;
                        }
                    }
                });
                
                if (!dependencyFound) {
                    if (lastValidIndex === -1) {
                        genderPriceDependencies.push(newDependency);
                    } else {
                        genderPriceDependencies.splice(lastValidIndex, 0, newDependency);
                    }
                }
            },
            removeDependency(dependency, idx) {
                const genderPriceDependencies = this.getProductEditPriceData.genderPriceDependencies;

                if (dependency.isNewDep) {
                    genderPriceDependencies.splice(idx, 1);
                } else {
                    dependency.isDeleted = true;
                    genderPriceDependencies.splice(idx, 1);
                    genderPriceDependencies.push(dependency);
                }
            },
            getDependencyValue(dependencySettings) {
                if (!dependencySettings) {
                    this.$set(this.getProductEditPriceData, 'dependencySettings', { dependencyType: 0 });
                    dependencySettings = this.getProductEditPriceData.dependencySettings;
                }

                return this.dependencyTypeOptions.find(depType => depType.id === dependencySettings.dependencyType).name;
            },
            updateDependencyType(event) {
                this.getProductEditPriceData.dependencySettings.dependencyType = event.id;
            },
            updateDependency(idx, priceCategory) {
                const genderPriceDependencies = this.getProductEditPriceData.genderPriceDependencies;
                const { audienceType, audienceTypeGroup, audienceTypeDescription } = priceCategory;
                const currentDep = genderPriceDependencies[idx];

                // Find existing dependency with matching audienceType and audienceTypeGroup, excluding the current index
                const eventIdx = genderPriceDependencies.findIndex((price, i) =>
                    i !== idx &&
                    price.genderPriceDependsOn.audienceType === audienceType &&
                    price.genderPriceDependsOn.audienceTypeGroup === audienceTypeGroup &&
                    price.genderPriceDependsOn.audienceTypeDescription === audienceTypeDescription
                );

                if (eventIdx !== -1) {
                    // Existing dependency found
                    const existingDep = genderPriceDependencies[eventIdx];
                    existingDep.isDeleted = false;

                    if (currentDep.isNewDep) {
                        // Replace current dependency with existing one
                        this.$set(genderPriceDependencies, idx, existingDep);
                        genderPriceDependencies.splice(eventIdx, 1);
                    } else {
                        // Archive current dependency and replace with existing one
                        currentDep.isDeleted = true;
                        const archivedDep = { ...currentDep };
                        this.$set(genderPriceDependencies, idx, existingDep);
                        genderPriceDependencies.splice(eventIdx, 1);
                        genderPriceDependencies.push(archivedDep);
                    }
                } else {
                    // No existing dependency found
                    if (currentDep.isNewDep) {
                        // Update current dependency with new audienceType and audienceTypeGroup
                        Object.assign(currentDep.genderPriceDependsOn, {
                            audienceType,
                            audienceTypeGroup,
                            audienceTypeDescription,
                            id: 0
                        });
                    } else {
                        // Archive current dependency and create a new one
                        currentDep.isDeleted = true;
                        const archivedDep = { ...currentDep };
                        Object.assign(currentDep, {
                            genderPriceDependsOn: {
                                audienceType,
                                audienceTypeGroup,
                                audienceTypeDescription,
                                id: 0
                            },
                            quantity: 1,
                            id: 0,
                            isDeleted: false,
                            isNewDep: true
                        });
                        genderPriceDependencies.push(archivedDep);
                    }
                }
            },
            cancel() {
                // Restore productGenderPriceComponents to the original
                this.$set(this.getProductEditPriceData, 'genderPriceDependencies', this.priceCategoryDependenciesCopy);
                this.$set(this.getProductEditPriceData, 'dependencySettings', null);

                // Normalize gender prices dependencies structure for BE
                this.normalizeGenderPricesDeps();
        
                this.closeModal();
            },
            restoreOriginalData() {
                // Normalize gender prices dependencies structure for BE
                this.normalizeGenderPricesDeps();

                // Restore productGenderPriceComponents to the original
                this.$set(this.getProductEditPriceData, 'genderPriceDependencies', this.priceCategoryDependenciesCopy);
                this.$set(this.getProductEditPriceData, 'dependencySettings', null);
            },
            save() {
                // Normalize gender prices dependencies structure for BE
                this.normalizeGenderPricesDeps();
                this.closeModal();
            }
        },
        components: {
            Modal,
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
    .btn-height {
        height: 39px;
    }

    .price-category-description {
        font-size: 2rem;
    }

    .modal-height {
        overflow-y: visible;
        height: 22rem;
    }

    .drop-size {
        width: 15rem;
    }

    .thead-size {
        height: 40px;
    }

    .tr-size {  
        height: 60px;
    }

    .min-size {
        min-height: 14rem;
    }
</style>
<style lang="scss">
    .table {
        tbody {
            tr {
                &:hover {
                    background-color: #f5f8fa;
                    cursor: pointer;
                    border: none;
                    transform: none;
                    position: relative;
                    z-index: 2;

                    &.disabled {
                        cursor: not-allowed;
                        background-color: #ffffff;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// GenderPricesDependencies.vue?7cd96427